module.exports = __webpack_public_path__ + "@/assets/img/hipercard.57589263.svg";